import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.branches')
  .factory('$branches', BranchesObjectFactory);

/* @ngInject */
function BranchesObjectFactory($bringozFactory: $bringozFactory,
                               branchesAPI: BringozApi,
                               Branches_DS: DataStoreConfig,
                               Branches_PN: PushNotificationsConfig) {

  function $branches(id: string) {
    return $bringozFactory(id, branchesAPI, Branches_DS, Branches_PN)
  }

  return $branches;
}
